export enum ValidationErrorsLocalizationId {
    DeactivatedUserError = "sign-in.deactivated_user_error",
    NotExistingAccountError = "sign-in.not_existing_account_error",
    AccountAlreadyExists = "sign-in.account_exists_error",
    SignUpHere = "sign-in.sign_up_link",
    DeactivatedUserErrorSupportEmail = "sign-in.deactivated_user_error_support_email",
    CodeAttemptsLeftError = "sign-in.enter_code_attempts_left_error",
    LockedUserError = "sign-in.locked_user_error",
}
